var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftEffect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 566,
    viewBox: "0 0 423 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_22183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_22183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_305_22183)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_22183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -202,
    y: 0,
    width: 624,
    height: 566
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.503 0H-201.594V565.8H421.503V0Z",
    fill: "url(#paint0_radial_305_22183)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_22183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 406.049H-13.2773V467.603H48.2767V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 406.049H48.2812V467.603H109.835V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 406.049H109.838V467.603H171.392V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 406.049H171.393V467.603H232.947V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 406.049H232.949V467.603H294.503V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 406.049H294.504V467.603H356.058V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 406.049H356.061V467.603H417.615V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 406.049H417.613V467.603H479.167V406.049Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 467.586H-13.2773V529.14H48.2767V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 -24.7188H-13.2773V36.8353H48.2767V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 467.586H48.2812V529.14H109.835V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 -24.7188H48.2812V36.8353H109.835V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 467.586H109.838V529.14H171.392V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 -24.7188H109.838V36.8353H171.392V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 467.586H171.393V529.14H232.947V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 -24.7188H171.393V36.8353H232.947V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 467.586H232.949V529.14H294.503V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 -24.7188H232.949V36.8353H294.503V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 467.587H294.504V529.141H356.058V467.587Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 -24.7188H294.504V36.8353H356.058V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 467.586H356.061V529.14H417.615V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 -24.7188H356.061V36.8353H417.615V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 467.586H417.613V529.14H479.167V467.586Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 -24.7188H417.613V36.8353H479.167V-24.7188Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 529.125H-13.2773V590.679H48.2767V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 36.8203H-13.2773V98.3744H48.2767V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 529.125H48.2812V590.679H109.835V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 36.8203H48.2812V98.3744H109.835V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 529.125H109.838V590.679H171.392V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 36.8203H109.838V98.3744H171.392V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 529.125H171.393V590.679H232.947V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 36.8203H171.393V98.3744H232.947V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 529.125H232.949V590.679H294.503V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 36.8203H232.949V98.3744H294.503V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 529.125H294.504V590.679H356.058V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 36.8203H294.504V98.3744H356.058V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 529.125H356.061V590.679H417.615V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 36.8203H356.061V98.3744H417.615V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 529.125H417.613V590.679H479.167V529.125Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 36.8203H417.613V98.3744H479.167V36.8203Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 98.3574H-13.2773V159.911H48.2767V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 98.3574H48.2812V159.911H109.835V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 98.3574H109.838V159.911H171.392V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 98.3584H171.393V159.912H232.947V98.3584Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 98.3574H232.949V159.911H294.503V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 98.3574H294.504V159.911H356.058V98.3574Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 98.3584H356.061V159.912H417.615V98.3584Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 98.3584H417.613V159.912H479.167V98.3584Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 159.896H-13.2773V221.45H48.2767V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 159.896H48.2812V221.451H109.835V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 159.896H109.838V221.45H171.392V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 159.896H171.393V221.45H232.947V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 159.896H232.949V221.451H294.503V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 159.896H294.504V221.451H356.058V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 159.896H356.061V221.45H417.615V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 159.896H417.613V221.45H479.167V159.896Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 221.434H-13.2773V282.988H48.2767V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 221.434H48.2812V282.988H109.835V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 221.434H109.838V282.988H171.392V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 221.434H171.393V282.988H232.947V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 221.434H232.949V282.988H294.503V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 221.434H294.504V282.988H356.058V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 221.434H356.061V282.988H417.615V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 221.434H417.613V282.988H479.167V221.434Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 282.973H-13.2773V344.527H48.2767V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 282.973H48.2812V344.527H109.835V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 282.973H109.838V344.527H171.392V282.973Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 282.974H171.393V344.528H232.947V282.974Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 282.974H232.949V344.528H294.503V282.974Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 282.974H294.504V344.528H356.058V282.974Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 282.974H356.061V344.528H417.615V282.974Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 282.974H417.613V344.528H479.167V282.974Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2767 344.511H-13.2773V406.065H48.2767V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.835 344.511H48.2812V406.065H109.835V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.392 344.511H109.838V406.065H171.392V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.947 344.511H171.393V406.065H232.947V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.503 344.511H232.949V406.065H294.503V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.058 344.511H294.504V406.065H356.058V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.615 344.511H356.061V406.065H417.615V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.167 344.511H417.613V406.065H479.167V344.511Z",
    stroke: "black",
    strokeOpacity: 0.13,
    strokeWidth: 1.50479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.5156 144.104V159.664H2.72102",
    stroke: "url(#paint1_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.5156 175.225V159.664H2.72102",
    stroke: "url(#paint2_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.65 205.67V221.568H278.75",
    stroke: "url(#paint3_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.312 205.67V221.229H310.551",
    stroke: "url(#paint4_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.312 236.791V221.229H310.551",
    stroke: "url(#paint5_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.315 236.791V221.229H278.078",
    stroke: "url(#paint6_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.214 328.801V344.699H340.314",
    stroke: "url(#paint7_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.879 328.801V344.36H372.116",
    stroke: "url(#paint8_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.879 359.921V344.36H372.116",
    stroke: "url(#paint9_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.875 359.921V344.36H339.639",
    stroke: "url(#paint10_linear_305_22183)",
    strokeWidth: 1.50479,
    strokeLinecap: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_305_22183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.954 282.9) rotate(90) scale(752.239 828.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_22183",
    x1: -13.7263,
    y1: 144.104,
    x2: 2.24852,
    y2: 160.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_22183",
    x1: -13.7263,
    y1: 175.225,
    x2: 2.24853,
    y2: 159.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_22183",
    x1: 294.856,
    y1: 205.67,
    x2: 278.545,
    y2: 221.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_305_22183",
    x1: 294.102,
    y1: 205.67,
    x2: 310.078,
    y2: 221.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_22183",
    x1: 294.102,
    y1: 236.791,
    x2: 310.078,
    y2: 220.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_305_22183",
    x1: 294.525,
    y1: 236.791,
    x2: 278.551,
    y2: 220.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_305_22183",
    x1: 356.42,
    y1: 328.801,
    x2: 340.11,
    y2: 344.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_305_22183",
    x1: 355.668,
    y1: 328.801,
    x2: 371.643,
    y2: 344.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_305_22183",
    x1: 355.668,
    y1: 359.921,
    x2: 371.643,
    y2: 343.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_305_22183",
    x1: 356.086,
    y1: 359.921,
    x2: 340.111,
    y2: 343.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394381,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_22183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 624.48,
    height: 565.8,
    fill: "white",
    transform: "translate(-201.59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_22183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 624.48,
    height: 565.8,
    fill: "white",
    transform: "translate(-201.59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_305_22183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 624.487,
    height: 565.8,
    fill: "white",
    transform: "translate(-201.594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftEffect);
export default __webpack_public_path__ + "static/media/left-effect.35c65634c872e8b22ffc13ef5afc1491.svg";
export { ForwardRef as ReactComponent };